<template>
  <div class="Login">
    <div class="d-flex align-items-center glavni">
      <div class="container">
        <form class="form-signin" @submit.prevent="login">
          <div class="box-login">
            <img class="mx-auto mb-5" src="../assets/img/NAVIGATION.svg" alt>

            <br>
          <div class="alert alert-danger w-50 mx-auto" v-if="error">{{ error }}</div> 
            
            <input
              v-model="email"
              class="col-5 round mx-auto mb-2 p-2 text-center border-0"
              type="email" name="email" id="email"
              placeholder="email"
            >
            <br>
            <input
              v-model="password"
              type="password" name="password" id="inputPassword"
              class="col-5 round mx-auto mb-4 p-2 text-center border-0"
              placeholder="Password"
            >
            <br>
            <button type="submit " class="btn btn-contact col-2">SIGN IN</button>
            <p class="mt-4 text-light">
              Forgot password? Or if you don’t have an account
              <router-link class="cyan" to="/Register">Click here</router-link>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: "",
      error: false
    };
  },
  methods: {
    login() {
        axios.post("https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/auth/login", { email: this.email, password: this.password })
        .then(request => this.loginSuccessful(request))
        .catch(() => this.loginFailed());
        
    },
    loginSuccessful(req) {
      if (!req.data.access_token) {
        this.loginFailed();
        return;
      }
      localStorage.token = req.data.access_token;
      localStorage.email = this.email;
      this.$swal({
        position: 'center',
        type: 'success',
        title: 'Login successful',
        showConfirmButton: false,
        timer: 2000
      });
      this.error = false;
      this.$router.replace(this.$route.query.redirect || "/Users");
      
      
    },
    loginFailed() {
      
      this.error = "Login failed!";
      delete localStorage.token;
      delete localStorage.email
    }
  }
};
</script>

<style scoped>
@import "../style.css";

.box-login {
  text-align: center;
  margin: auto;

  align-content: center;
}


.glavni {
  height: 100vh;
  background: url("../assets/img/group-5796.png") no-repeat;
}
.round {
  border-radius: 20px;
}

.btn-contact {
  background: #29e4b7;
  color: #fff;
  text-transform: capitalize;
  font-weight: bold;
  border-radius: 25px;
}

.cyan {
  color: #29e4b7;
}

::placeholder {
  color: #29e4b7;
  font-weight: bold;
}

input {
  outline: none;
}
</style>